import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const initialValues = {
  cart: {},
  items: [],
  totals: [],
  shippingAddress: null,
  showShippingMethods: false,
  showPayments: false,
  shippingMethods: [],
  activeShippingMethod: null,
  pickupStore: {},
  mainUserAddress: {},
  userAddresses: [],
  payments: null,
  regions: [],
  mobiles: {},
  tel: null,
  mapLocation: null,
};

const useCheckout = create(
  persist(
    (set) => ({
      ...initialValues,
      isHydrated: false,
      setHydrated: (state) => set({ isHydrated: state }),
      setCart: (cart) =>
        set(() => ({
          cart,
          items: cart?.items || [],
          totals: cart?.total_segments || [],
        })),

      setShippingAddress: (shippingAddress) => set(() => ({ shippingAddress })),

      setMapLocation: (mapLocation) => set(() => ({ mapLocation })),

      setShowShippingMethods: (showShippingMethods) =>
        set(() => ({ showShippingMethods })),

      setShowPayments: (showPayments) => set(() => ({ showPayments })),

      setShippingMethods: (shippingMethods) => set(() => ({ shippingMethods })),

      setActiveShippingMethod: (activeShippingMethod) =>
        set(() => ({ activeShippingMethod })),

      setPickupStore: (pickupStore) => set(() => ({ pickupStore })),

      setPayments: (payments) => {
        const pays = [...(payments || [])];
        const tamaraIdx = pays?.findIndex((payment) =>
          payment?.code?.includes('tamara')
        );
        if (tamaraIdx === -1) {
          pays.push({
            arabic_name: 'تمارا',
            code: 'tamara_pay_by_instalments',
            english_name: 'Split into 3 payments, without fees with Tamara',
            is_available: true,
            title: 'قسم المبلغ على ثلاث دفعات مع تمارا',
          });
        }
        pays[tamaraIdx] = {
          arabic_name: 'قسم المبلغ على ثلاث دفعات مع تمارا',
          code: 'tamara_pay_by_instalments',
          english_name: 'Tamara',
          is_available: true,
          title: 'قسم المبلغ على ثلاث دفعات مع تمارا',
        };
        return set(() => ({ payments: pays }));
      },

      setRegions: (regions) => set(() => ({ regions })),

      setUserAddresses: (userAddresses) => set(() => ({ userAddresses })),

      setMainUserAddress: (mainUserAddress) => set(() => ({ mainUserAddress })),

      setTel: (tel) => set(() => ({ tel })),

      removeItem: (itemId) =>
        set((state) => {
          // Remove the item from the cart
          const updatedCartItems = state.cart?.items?.filter(
            (item) => item.item_id !== itemId
          );
          return {
            ...state,
            cart: { ...state?.cart, items: updatedCartItems },
          };
        }),

      setMobiles: ({ mobile, status }) =>
        set((state) => ({
          mobiles: { ...state.mobiles, [mobile]: status },
        })),

      clearCheckout: () => set(initialValues),
    }),
    {
      name: 'checkout',
      onRehydrateStorage: () => (state) => {
        state.setHydrated(true);
      },
    }
  )
);

export default useCheckout;
